import Phaser from "phaser";
import GameCore from "./GameCore";
import GameSound from "./GameSound";
import SceneManager from "./SceneManager";

export default class Game extends Phaser.Game {
  static _core: GameCore;
  static _sound: GameSound;
  SceneManager: SceneManager;

  static get Core(): GameCore {
    return this._core;
  }
  static set Core(core: GameCore) {
    window["game"] = core;
    this._core = core;
  }

  static get Sound() {
    return this._sound;
  }
  static set Sound(sound: GameSound) {
    this._sound = sound;
  }

  constructor(config: Phaser.Types.Core.GameConfig) {
    super(config);
    // SceneManager is initialized in PreloadScene, not here
    this.initialize();
  }

  initialize() {
    // Initialize debug access when the game is ready
    this.events.once("ready", () => {
      // Add debugging capability to access the router from dev console
      if (process.env.NODE_ENV === "development") {
        // @ts-ignore
        window.game = this;
        // @ts-ignore
        window.router = Game.Core?.SceneManager?.router;

        // Add special deals debugging functions
        // @ts-ignore
        window.specialDeals = {
          // @ts-ignore
          show: () =>
            import("../../services/SpecialDealsService").then(
              ({ SpecialDealsService }) =>
                SpecialDealsService.forceShowSpecialDeals()
            ),
          // @ts-ignore
          reset: () =>
            import("../../services/SpecialDealsService").then(
              ({ SpecialDealsService }) =>
                SpecialDealsService.resetSessionCheck()
            ),
          // @ts-ignore
          check: () =>
            import("../../services/SpecialDealsService").then(
              ({ SpecialDealsService }) =>
                SpecialDealsService.isEligibleForSpecialDeals()
            ),
          // @ts-ignore
          clearStorage: () => {
            localStorage.removeItem("last_visit_time");
            localStorage.removeItem("special_deals_shown_today");
            console.log("Special deals storage cleared");
          },
          // @ts-ignore
          setLastVisit: (hoursAgo: number) => {
            const time = Date.now() - hoursAgo * 60 * 60 * 1000;
            localStorage.setItem("last_visit_time", time.toString());
            console.log(`Last visit set to ${hoursAgo} hours ago`);
          },
        };
      }
    });

    // Do not pause sound when TG popups are shown
    this.sound.pauseOnBlur = false;
  }

  /**
   * Apply new resolution
   */
  static ApplyGameResolution() {}

  /**
   * Apply menu resolution
   */
  static ApplyMenuResolution() {}
}
